var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusicStars = function SvgMusicStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.783 21.375a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0m7.5-2.25a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.533 21.375v-6.794a1.5 1.5 0 0 1 1.025-1.423l4.5-1.25a1.5 1.5 0 0 1 1.975 1.423v5.794M19.5.75c-.009 2.356 1.14 3.7 3.75 3.75-2.423-.009-3.627 1.291-3.75 3.75-.021-2.32-1.06-3.75-3.75-3.75 2.407-.033 3.741-1.195 3.75-3.75M6.033 2.935c-.013 3.318 1.6 5.2 5.282 5.283C7.9 8.205 6.206 10.036 6.033 13.5 6 10.232 4.539 8.213.75 8.218c3.39-.048 5.27-1.684 5.283-5.283"
  })));
};
export default SvgMusicStars;